<script>
  import { Donate } from "@ObamaFoundation/of-design-system";
  import { setContext } from "svelte";

  export let description;
  export let disclaimer;
  export let subtitle = null;
  export let theme = "skyBlue";
  export let variant = "form";

  setContext("containerized", true);
  setContext("donateDescendant", true);
</script>

<Donate {description} {disclaimer} {variant} {theme} {subtitle} embedTitle="Select an amount">
  <slot name="title" slot="title" />
  <slot name="embed" slot="embed" />
</Donate>
